import { LocalStorageHelper } from "@/core/helper/local-storage-helper";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

const fallbackLng = [LocalStorageHelper.setAndGetDefaultCultureAndLanguageByDomainBeforeLogin()];
await i18n
  .use(Backend)
  .use(LanguageDetector) // detects the current language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng, // default language
    detection: {
      checkWhitelist: true,
    },
    lng: LocalStorageHelper.setAndGetDefaultCultureAndLanguageByDomainBeforeLogin(),
    load: "currentOnly",
    ns: ['translation', 'syncflow'],
    defaultNS: 'translation',
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    debug: false,
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;